import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import hubspotLogo from 'Shared/images/HubspotLogo.svg';
import HubspotSmartMenu from '../SmartMenu/HubspotSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';
import { useFlags } from 'launchdarkly-react-client-sdk';

type Props = {
  children: React.ReactNode;
};

const HubspotLink = ({ children, ...restProps }: Props) => {
  const { hubspotIntegration } = useFlags();

  const SmartLinkJsx = ({ children }) => {
    return (
      <SmartLink {...restProps} hasBadge>
        <SmartLinkLogo src={hubspotLogo} />
        {children}
      </SmartLink>
    );
  };

  return (
    <SmartLinkContainer contentEditable={false}>
      {hubspotIntegration ? (
        <HubspotSmartMenu {...restProps}>
          <SmartLinkJsx>{children}</SmartLinkJsx>
        </HubspotSmartMenu>
      ) : (
        <SmartLinkJsx>{children}</SmartLinkJsx>
      )}
    </SmartLinkContainer>
  );
};

export default HubspotLink;
